import { Fragment, useContext, useEffect, useState } from 'react';
import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import Loading from '../../ui-elements/Loading';
import Tray from '../Tray';
import SeedSlotConfirm from './SeedSlotConfirm';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../layout/BackButton';
import AuthContext from '../../../contexts/auth/AuthContext';

const ConfirmSeedingSelection = ({ backwardTo, completingRef }) => {
  const {
    activeProcessId,
    activeProcessType,
    processes,
    processTypes,
    taskData,
    occupancyArray,
    loadOccupancy,
    additionalProcessInformation,
    continueProcess,
    backIsAllowed,
    finishProcess
  } = useContext(ProcessContext);
  const { loadAndSetAccessibleSeedTypesAsync, currentTenant, currentContainer  } = useContext(AuthContext);
  const { loading, setInfo, clearInfo } = useContext(UIContext);
  const navigate = useNavigate();
  const [confirmed, setConfirmed] = useState(false);
  const showBackButton = backIsAllowed;

  useEffect(() => {
    async function initContextInfo() {
      await loadOccupancy(additionalProcessInformation.destinationEntity);
      clearInfo();
       let processTitle = null
       if (Array.isArray(processes) && processes.length) {
         if (typeof activeProcessType === 'string') {
           const enumValue = processTypes?.[activeProcessType]
           if (typeof enumValue === 'number') {
             processTitle = processes.find(p => p.type === enumValue)?.title
           }
         } else if (typeof activeProcessType === 'number') {
           processTitle = processes.find(p => p.type === activeProcessType)?.title
         }
       }

       processTitle = processTitle ||
         (typeof activeProcessType === 'string'
            ? activeProcessType.toUpperCase()
            : '—')
      setInfo({
        processType: processTitle,
        seedType: additionalProcessInformation.seedType,
        tray: additionalProcessInformation.destinationEntity,
        plants: additionalProcessInformation.destinationSelection.length,
      });
    }
    initContextInfo();
  }, []);

  const confirmSelection = async () => {
    try {
      if (confirmed) return;
      setConfirmed(true);

      await continueProcess(activeProcessId, true);

      if (completingRef) {
        await loadAndSetAccessibleSeedTypesAsync(currentTenant, currentContainer, true, 'seedVariantTypes');
        completingRef.current = true;
        await finishProcess();

        if (taskData?.redirectUrl) {
          window.location.href = taskData.redirectUrl;
          return;
        }

        if (taskData) {
          navigate('/', { state: { slide: 1 } });
        } else {
          navigate('/');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reversedArray = [...occupancyArray].reverse();
  return loading || confirmed ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      {showBackButton && (
        <BackButton disabled={!backIsAllowed} navigateTo={backwardTo} />
      )}

      {!confirmed && (
        <Tray>
          {occupancyArray &&
            occupancyArray.length > 0 &&
            reversedArray.map((unit) => (
              <SeedSlotConfirm
                key={unit.index}
                displayName={unit.display}
                index={unit.index}
                seedType={additionalProcessInformation.seedType}
                isMultiharvestable={additionalProcessInformation.isMultiharvestable}
              />
            ))}
        </Tray>
      )}

      <StatusBarButton
        label="Confirm"
        icon="fas fa-check"
        reversed={true}
        clickHandler={confirmSelection}
        statusSlot={5}
      />
    </Fragment>
  );
};

export default ConfirmSeedingSelection;
